<template>
  <div class="customer">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="客户关系管理"
        class="customer-edit"
        width="800px"
        top="5vh">
      <div style="display: flex;flex-direction: row;margin-bottom: 5%">
        <div style="display: flex;flex-direction: row;width: 40%;margin-right: 10%">
          <span style="display: block;width: 25%">销售员：</span>
          <el-input v-model="customerBelongtoEmployee.employeeName" placeholder="请输入" readonly>
            <el-button slot="append" icon="el-icon-search" @click="$refs.selectEmployee.open()">选择</el-button>
          </el-input>
          <employee-select ref="selectEmployee" @select="selectEmployee"/>
        </div>
        <div style="display: flex;flex-direction: row;width: 40%">
          <span style="display: block;width: 32%">新销售员：</span>
          <el-input v-model="customerBelongtoEmployee.newEmployeeName" placeholder="请输入" readonly>
            <el-button slot="append" icon="el-icon-search" @click="$refs.selectNewEmployee.open()">选择</el-button>
          </el-input>
          <employee-select ref="selectNewEmployee" @select="selectNewEmployee"/>
        </div>
      </div>
      <el-transfer
          v-model="customerBelongtoEmployee.customerIds"
          style="margin-left: 20px;"
          filterable
          :data="customerList"
          :props="{key: 'customerID', label: 'customerName'}"
          :titles="['已包含客户', '未包含客户']"/>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  export default {
    name:"RelationshipManage",
    components: {EmployeeSelect},
    data() {
      return {
        activeName: "first",
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        checkAll: false,
        customerList: [],
        customerBelongtoEmployee:{
          employeeName: "",
          newEmployeeName: "",
          customerIds: [],
          customerID: "",
          employeeID: "",
          newEmployeeID: "",
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(id) {
        console.log(id);
        this.dialogVisible = true;
      },
      getData() {
        this.$http
          .get("basic", "customers")
          .then(resp => {
            console.log(resp);
            //this.roleList = resp;
          });
      },
      selectEmployee(row) {
        this.customerBelongtoEmployee.employeeID = row.employeeID;
        this.customerBelongtoEmployee.employeeName = row.employeeName;
        this.getCustomerList();
        this.getExcludeCustomerList();
      },
      selectNewEmployee(row) {
        this.customerBelongtoEmployee.newEmployeeID = row.employeeID;
        this.customerBelongtoEmployee.newEmployeeName = row.employeeName;
      },
      getCustomerList() {
        this.$http
          .get("basic", `customers/employeeID/${this.customerBelongtoEmployee.employeeID}`)
          .then(resp => {
            console.log(resp);
            //this.customerList = resp;
          });
      },
      getExcludeCustomerList() {
        this.$http
          .get("basic", `customers/excludeEmployeeID/${this.customerBelongtoEmployee.employeeID}`)
          .then(resp => {
            console.log(resp);
            this.customerList = resp;
          });
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "customers", this.customer)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss">
  .customer{
    .el-form-item--mini .el-form-item__content div:last-child{
      margin-left: 0!important;
    }
    .el-radio-group{
      margin-top: 3%;
    }
    .el-form-item--mini .el-form-item__content{
      display: flex;
      flex-direction: row;
      div:last-child{
        margin-left: 3%;
      }
    }
  }
</style>
